<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-overlay
      :absolute="true"
      :dark="false"
      z-index="9999"
    >
      <v-card width="350" class="rounded-lg">
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text>
          <template v-for="(field, index) in rows" >
            <v-text-field
              v-if="field.component === 'text-field'"
              v-model="markerData[field.key]"
              :label="field.label"
              :type="field.type"
              v-validate="{
                required: true
              }"
              :error-messages="errors.collect(field.label)"
              :data-vv-name="field.label"
              :key="index + '-text-field'"
              hide-details="auto"
            />
            <v-select
              v-else-if="field.component === 'select'"
              v-model="markerData[field.key]"
              :label="field.label"
              :items="field.list"
              v-validate="{
                required: true
              }"
              :error-messages="errors.collect(field.label)"
              :data-vv-name="field.label"
              :key="index + '-select'"
              hide-details="auto"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" dark text @click="cancel">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import L from 'leaflet'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: () => null
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      markerData: { ...this.item.options.data }
    }
  },
  mounted () {
    L.DomEvent.disableClickPropagation(this.$el)
    L.DomEvent.disableScrollPropagation(this.$el)
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          const result = await this.item.updateMarker(this.markerData, this.item)
          if (result) {
            this.item.options.data = this.markerData
            this.$emit('close')
          }
        }
      })
    }
  }
}
</script>
